module.exports = __webpack_public_path__ + "img/318.dbe83172.jpg";